import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Paper,
  useTheme
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import parse from 'html-react-parser';

const ReadingTest = ({
  id,
  title,
  content,
  onFinish,
}) => {
  const theme = useTheme();
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <Container maxWidth="md">
      <Paper
        elevation={2}
        sx={{
          p: 4,
          borderRadius: 2,
          height: '75vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header with test number and timer */}
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Typography
            variant="h3"
            component="h1"
            color="primary"
            sx={{ 
              fontWeight: theme.typography.fontWeightMedium,
              fontSize: {
                xs: '2rem',
                sm: '2.5rem',
                md: '3rem'
              }
            }}
          >
            {parse(title)}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AccessTimeIcon sx={{ color: 'primary.main' }} />
            <Typography
              variant="h6"
              color="primary"
              sx={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              {formatTime(seconds)}
            </Typography>
          </Box>
        </Box>

        {/* Main content with scroll */}
        <Box 
          sx={{ 
            flex: 1,
            overflow: 'auto',
            pr: 2,
            mr: -2,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'rgba(0,0,0,0.1)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,0.2)',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.3)',
              },
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              '& > h2': {
                fontSize: '1.5rem',
                fontWeight: theme.typography.fontWeightMedium,
                marginBottom: theme.spacing(3),
                marginTop: 0,
              },
              '& > p': {
                marginBottom: theme.spacing(2),
              }
            }}
          >
            {parse(content)}
          </Typography>
        </Box>

        {/* Footer with button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            variant="contained"
            onClick={() => {
              if (seconds > 0) {
                onFinish(seconds)
              }
            }}
            size="large"
            sx={{
              px: 6,
              py: 1.5,
              borderRadius: '24px',
              boxShadow: theme.shadows[2],
              '&:hover': {
                boxShadow: theme.shadows[4],
              },
            }}
          >
            TERMINAR
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ReadingTest;

